import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from './';
import { history } from '../_helpers';

export const userActions = {
    login,
    logout,
    register,
    activate,
    resetPassword,
    setPassword,
    update,
    updateNoOrg,
    submitStripe,
    getAll,
    getOwn,
    getByEmail,
    delete: _delete,
};

function login(username, password) {
    return (dispatch) => {
        dispatch(request({ username }));

        userService.login(username, password)
            .then(
                (user) => {
                    dispatch(success(user));
                    history.push('/');
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                },
            );
    };

    function request(user) {
        return { type: userConstants.LOGIN_REQUEST, user };
    }
    function success(user) {
        return { type: userConstants.LOGIN_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.LOGIN_FAILURE, error };
    }
}

function logout() {
    userService.logout();
    history.push('/login');
    return { type: userConstants.LOGOUT };
}

function register(values) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        userService.register(values)
            .then(
                (response) => {
                    dispatch(success(response));
                    dispatch(alertActions.success('Registration successful'));
                    resolve(response);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    dispatch(alertActions.error(error.toString()));
                    reject(error);
                },
            );
    });

    function request() {
        return { type: userConstants.REGISTER_REQUEST };
    }
    function success(user) {
        return { type: userConstants.REGISTER_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.REGISTER_FAILURE, error };
    }
}

function activate(token) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        userService.activate(token)
            .then(
                (response) => {
                    dispatch(success(response));
                    resolve(response);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.ACTIVATE_REQUEST };
    }
    function success() {
        return { type: userConstants.ACTIVATE_SUCCESS };
    }
    function failure(error) {
        return { type: userConstants.ACTIVATE_FAILURE, error };
    }
}

function resetPassword(email) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        userService.resetPassword(email)
            .then(
                (response) => {
                    dispatch(success(response));
                    resolve(response);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request(email) {
        return { type: userConstants.RESETPASSWORD_REQUEST, email };
    }
    function success(response) {
        return { type: userConstants.RESETPASSWORD_SUCCESS, response };
    }
    function failure(error) {
        return { type: userConstants.RESETPASSWORD_FAILURE, error };
    }
}

function setPassword(values) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());
        userService.setPassword(values)
            .then(
                (response) => {
                    dispatch(success(response));
                    resolve(response);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.SETPASSWORD_REQUEST };
    }
    function success(response) {
        return { type: userConstants.SETPASSWORD_SUCCESS, response };
    }
    function failure(error) {
        return { type: userConstants.SETPASSWORD_FAILURE, error };
    }
}

function update(user) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request(user));
        userService.update(user)
            .then(
                (user) => {
                    dispatch(success(user));
                    resolve(user);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.UPDATE_REQUEST };
    }
    function success(user) {
        return { type: userConstants.UPDATE_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.UPDATE_FAILURE, error };
    }
}

function updateNoOrg(user) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request(user));
        userService.updateNoOrg(user)
            .then(
                (user) => {
                    dispatch(success(user));
                    resolve(user);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.UPDATENOORG_REQUEST };
    }
    function success(user) {
        return { type: userConstants.UPDATENOORG_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.UPDATENOORG_FAILURE, error };
    }
}

function submitStripe(stripeToken) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        userService.submitStripe(stripeToken)
            .then(
                (user) => {
                    dispatch(success(user));
                    resolve(user);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.SUBMITSTRIPE_REQUEST };
    }
    function success(user) {
        return { type: userConstants.SUBMITSTRIPE_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.SUBMITSTRIPE_FAILURE, error };
    }
}

function getAll() {
    return (dispatch) => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: userConstants.GETALL_REQUEST };
    }
    function success(users) {
        return { type: userConstants.GETALL_SUCCESS, users };
    }
    function failure(error) {
        return { type: userConstants.GETALL_FAILURE, error };
    }
}

function getOwn() {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        userService.getOwn()
            .then(
                (user) => {
                    dispatch(success(user));
                    resolve(user);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.GETOWN_REQUEST };
    }
    function success(user) {
        return { type: userConstants.GETOWN_SUCCESS, user };
    }
    function failure(error) {
        return { type: userConstants.GETOWN_FAILURE, error };
    }
}

function getByEmail(email) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        userService.getByEmail(email)
            .then(
                (userByEmail) => {
                    dispatch(success(userByEmail));
                    resolve(userByEmail);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: userConstants.GETBYEMAIL_REQUEST };
    }
    function success(userByEmail) {
        return { type: userConstants.GETBYEMAIL_SUCCESS, userByEmail };
    }
    function failure(error) {
        return { type: userConstants.GETBYEMAIL_FAILURE, error };
    }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return (dispatch) => {
        dispatch(request(id));

        userService.delete(id)
            .then(
                user => dispatch(success(id)),
                error => dispatch(failure(id, error.toString())),
            );
    };

    function request(id) {
        return { type: userConstants.DELETE_REQUEST, id };
    }
    function success(id) {
        return { type: userConstants.DELETE_SUCCESS, id };
    }
    function failure(id, error) {
        return { type: userConstants.DELETE_FAILURE, id, error };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/user.actions.js